import { useMutation, useQueryClient } from "@tanstack/react-query";
import { setReminder } from "../../services/apiLeads";

export function useSetReminder() {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ proposalId, reminderEnabled }) => {
      return await setReminder(proposalId, reminderEnabled);
    },
    {
      onSuccess: (_, { proposalId, reminderEnabled }) => {
        console.log(`Reminder set for Proposal ID: ${proposalId} with Option: ${reminderEnabled}`);

        queryClient.invalidateQueries(["leads"]); 
      },
      onError: (error, { proposalId }) => {
        console.error(`Failed to set reminder for Proposal ID: ${proposalId}`, error);
      },
    }
  );
}
